module.exports = __webpack_public_path__ + "static/media/enable-sound.eb2df213.svg";